import { Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField } from "@mui/material";
import React from "react";
import {useContext, useState} from 'react';
import { ProjectContext } from "../../contexts/ProjectContext";
import AddIcon from '@mui/icons-material/Add';
import { ElementData } from "../../data/elementData";

export const NewSimpleNodeDialog = (props) => {
  const [newElement, setNewElement] = useState(ElementData);

  const { addNode } = useContext(ProjectContext);

  const handleAdd = () => {
    console.log("adding " + props.nodetype);
    addNode(newElement, props.nodetype);
    //props.refreshLayout();
    props.handleClose();
  }

  const handleClose = (event, reason) => {
    if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
      props.handleClose();
    }
  }

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setNewElement((prev) => {
      return { ...prev, [name]: value }
    });
  };

  return (
    <div>
      <Dialog open={props.open} maxWidth="sm" fullWidth onClose={handleClose}>
        <DialogTitle>Add Node</DialogTitle>
        <DialogContent>
          <TextField size="small" required margin="dense" name="name" label="Name" type="text" fullWidth onChange={handleChange} />
        </DialogContent>
        <DialogActions>
          <Button onClick={props.handleClose} variant="outlined">Cancel</Button>
          <Button onClick={handleAdd} variant="contained" color="success" startIcon={<AddIcon />}>Add</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}